import React, { memo } from 'react'
import CloseOutlinedIcon from '@material-ui/icons/CloseOutlined'
import ImproveScoreRange from 'core/assets/images/improve-score-range.png'
import i18n from 'core/common/i18n'
import { Typography, Divider, IconButton } from 'core/components/Core'
import Modal from 'core/components/Modal'
import { SidebarItem } from 'core/pages/ProductImproveScore/components/ImproveScoreSidebar/SidebarItem'
import { TProductDialogRelevance } from './ProductDialogRelevance.types'

const ProductDialogRelevance: React.FC<TProductDialogRelevance> = ({ open, onClose }) => {
  return (
    <Modal
      title={
        <div className="d-flex justify-between">
          <Typography variant="h5">{i18n.t('productNew.productDialogRelevance.title')}</Typography>

          <IconButton
            size="small"
            onClick={onClose}
            aria-label={i18n.t('productNew.productDialogRelevance.closeButtonAriaLabel')}
          >
            <CloseOutlinedIcon />
          </IconButton>
        </div>
      }
      open={open}
      onCancel={onClose}
      maxWidth="md"
    >
      <div className="d-flex">
        <div style={{ width: '50%', marginRight: 30 }}>
          <Typography variant="body1" className="mb-3">
            {i18n.t('productNew.productDialogRelevance.subtitle1')}
          </Typography>

          <Typography
            variant="body1"
            color="textPrimary"
            className="mb-3"
            style={{ fontWeight: 700 }}
          >
            {i18n.t('productNew.productDialogRelevance.score')}
          </Typography>

          <img
            src={ImproveScoreRange}
            alt={i18n.t('improveScore.improveScoreRange')}
            className="mb-3 max-w-100"
          />

          <Typography variant="body1">
            {i18n.t('productNew.productDialogRelevance.subtitle2')}
          </Typography>
        </div>

        <div style={{ width: '50%' }}>
          <SidebarItem title={i18n.t('improveScore.rules.title.name')}>
            <div className="d-flex justify-between p-1">
              <Typography variant="body2">
                {i18n.t('improveScore.rules.title.rule1.rule')}
              </Typography>

              <Typography variant="body2">
                {i18n.t('improveScore.rules.title.rule1.points')}
              </Typography>
            </div>

            <Divider />

            <div className="d-flex justify-between p-1">
              <Typography variant="body2" className="w-75">
                {i18n.t('improveScore.rules.title.rule2.rule')}
              </Typography>

              <Typography variant="body2">
                {i18n.t('improveScore.rules.title.rule2.points')}
              </Typography>
            </div>

            <Divider />

            <div className="d-flex justify-between p-1">
              <Typography variant="body2" className="w-75">
                {i18n.t('improveScore.rules.title.rule3.rule')}
              </Typography>

              <Typography variant="body2">
                {i18n.t('improveScore.rules.title.rule3.points')}
              </Typography>
            </div>
          </SidebarItem>

          <SidebarItem title={i18n.t('improveScore.rules.ean.name')}>
            <div className="d-flex justify-between p-1">
              <Typography variant="body2" className="w-75">
                {i18n.t('improveScore.rules.ean.rule1.rule')}
              </Typography>

              <Typography variant="body2">
                {i18n.t('improveScore.rules.ean.rule1.points')}
              </Typography>
            </div>

            <Divider />

            <div className="d-flex justify-between p-1">
              <Typography variant="body2" className="w-75">
                {i18n.t('improveScore.rules.ean.rule2.rule')}
              </Typography>

              <Typography variant="body2">
                {i18n.t('improveScore.rules.ean.rule2.points')}
              </Typography>
            </div>
          </SidebarItem>

          <SidebarItem title={i18n.t('improveScore.rules.description.name')}>
            <div className="d-flex justify-between p-1">
              <Typography variant="body2" className="w-75">
                {i18n.t('improveScore.rules.description.rule1.rule')}
              </Typography>

              <Typography variant="body2">
                {i18n.t('improveScore.rules.description.rule1.points')}
              </Typography>
            </div>

            <Divider />

            <div className="d-flex justify-between p-1">
              <Typography variant="body2" className="w-75">
                {i18n.t('improveScore.rules.description.rule2.rule')}
              </Typography>

              <Typography variant="body2">
                {i18n.t('improveScore.rules.description.rule2.points')}
              </Typography>
            </div>

            <div className="d-flex justify-between p-1">
              <Typography variant="body2" className="w-75">
                {i18n.t('improveScore.rules.description.rule3.rule')}
              </Typography>

              <Typography variant="body2">
                {i18n.t('improveScore.rules.description.rule3.points')}
              </Typography>
            </div>
          </SidebarItem>

          <SidebarItem
            title={i18n.t('improveScore.rules.images.name')}
            subtitle={i18n.t('improveScore.rules.images.subtitle')}
          >
            <div className="d-flex justify-between p-1">
              <Typography variant="body2" className="w-75">
                {i18n.t('improveScore.rules.images.rule1.rule')}
              </Typography>

              <Typography variant="body2">
                {i18n.t('improveScore.rules.images.rule1.points')}
              </Typography>
            </div>

            <Divider />

            <div className="d-flex justify-between p-1">
              <Typography variant="body2" className="w-75">
                {i18n.t('improveScore.rules.images.rule2.rule')}
              </Typography>

              <Typography variant="body2">
                {i18n.t('improveScore.rules.images.rule2.points')}
              </Typography>
            </div>
          </SidebarItem>

          <SidebarItem title={i18n.t('improveScore.rules.datasheet.name')}>
            <div className="d-flex justify-between p-1">
              <Typography variant="body2" className="w-75">
                {i18n.t('improveScore.rules.datasheet.rule1.rule')}
              </Typography>

              <Typography variant="body2">
                {i18n.t('improveScore.rules.datasheet.rule1.points')}
              </Typography>
            </div>

            <Divider />

            <div className="d-flex justify-between p-1">
              <Typography variant="body2" className="w-75">
                {i18n.t('improveScore.rules.datasheet.rule2.rule')}
              </Typography>

              <Typography variant="body2">
                {i18n.t('improveScore.rules.datasheet.rule2.points')}
              </Typography>
            </div>

            <Divider />

            <div className="d-flex justify-between p-1">
              <Typography variant="body2" className="w-75">
                {i18n.t('improveScore.rules.datasheet.rule3.rule')}
              </Typography>

              <Typography variant="body2">
                {i18n.t('improveScore.rules.datasheet.rule3.points')}
              </Typography>
            </div>
          </SidebarItem>
        </div>
      </div>
    </Modal>
  )
}

export default memo(ProductDialogRelevance)
